/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ForecastImportReport } from '../../models/forecast-import-report';

export interface ImportStationForecast$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
      body?: Blob
}

export function importStationForecast(http: HttpClient, rootUrl: string, params: ImportStationForecast$Params, context?: HttpContext): Observable<StrictHttpResponse<ForecastImportReport>> {
  const rb = new RequestBuilder(rootUrl, importStationForecast.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'application/vnd.ms-excel');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ForecastImportReport>;
    })
  );
}

importStationForecast.PATH = '/stations/{uid}/data/forecast/import';
